import {JSX} from "react";

import {LocationOption} from "@/features/locations";

interface LocationSectionProps {
    title: string;
    options: ReadonlyArray<LocationOption>;
    onSelect: (option: LocationOption) => void;
}
export function LocationSection({title, options, onSelect}: LocationSectionProps): JSX.Element | null {
    if (options.length === 0) return null;

    const titleId = `location-section-${title}`;

    return (
        <div className="location-search__section">
            <div id={titleId} className="location-search__section-title">
                {title}
            </div>

            <div className="location-search__options" role="listbox" aria-labelledby={titleId}>
                {options.map((option) => (
                    <div
                        key={option.id}
                        role="option"
                        aria-selected={false}
                        tabIndex={-1}
                        spellCheck={false}
                        autoCorrect="off"
                        autoCapitalize="off"
                        className="location-search__option"
                        onMouseDown={(e) => {
                            e.preventDefault();
                            onSelect(option);
                        }}
                    >
                        <span>{option.name}</span>
                        {option.state && <span className="location-search__option-state">, {option.state}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
}
